function ProfessionalSummary(): JSX.Element {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Professional Summary</h2>
      <div className="text-gray-700 leading-relaxed">
        <p>
          Full-stack developer with 9+ years of experience in web development, cloud infrastructure,
          DevOps, and AI-driven systems. Currently building multi-agent AI frameworks with DDD and
          microservices architecture. Proven success in reducing operational costs (60% AWS cost reduction),
          optimizing system performance, and delivering seamless user experiences.
          Highly skilled in Python/FastAPI, PHP/Laravel, Vue.js, React/TypeScript, AWS, Kubernetes and modern architectural patterns.
          Passionate about AI agent orchestration and applying cutting-edge technologies to real-world challenges.
        </p>
      </div>
    </div>
  );
}

export default ProfessionalSummary;